import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-tabtest',
  templateUrl: './tabtest.component.html',
  styleUrls: ['./tabtest.component.scss']
})
export class TabtestComponent implements OnInit {
navLinks = [
    {path: '/app/admin/people', label: 'Users'},
    {path: '/app/admin/', label: 'Lists'}
];
  constructor(private router: Router) { }

  ngOnInit() {
  }
onTest() {
    this.router.navigate(['/app/admin']);
}
}
